// Audit why this is being used for both navigation props and for things like titles
export enum DrawerRoutes {
  about = 'about',
  admin = 'admin',
  lobby = 'lobby',
  homeScreen = 'homeScreen',
  logout = 'logout',
  game = 'game',
  share = 'share',
  buy = 'buy',
  pauseGame = 'pauseGame',
  playGame = 'playGame',
  showCards = 'showCards',
  hideCards = 'hideCards',
  show4ColorDeck = 'show4ColorDeck',
  hide4ColorDeck = 'hide4ColorDeck',
  profileScreen = 'profileScreen',
  profileScreenInGame = 'profileScreenInGame',
  notifications = 'notifications',
  sound = 'sound',
  shop = 'shop',
  name = 'name',
  signup = 'signup',
  terminateGame = 'Terminate Game',
  activeGames = 'activeGames',
  leaderboard = 'leaderboard',
  support = 'support',
  miniGamesLobby = 'miniGamesLobby',
  learningScreen = 'learningScreen',
  termsOfService = 'Terms of Service',
  privacyPolicy = 'Privacy Policy',
  startPlaying = 'startPlaying',
  emailUpdates = 'emailUpdates',
  realTimeUpdates = 'realTimeUpdates',
  cheatSheet = 'cheatSheet',
  eventScreen = 'eventScreen',
  whereAreYouScreen = 'whereAreYouScreen',
  whichEventScreen = 'whichEventScreen',
  whichClassTypeScreen = 'whichClassTypeScreen',
  changeNameScreen = 'ChangeNameScreen',
  liveEventNameScreen = 'liveEventNameScreen',
  leaveGame = 'leaveGame',
  webview = 'webview',
  editProfile = 'editProfile',
  playHistory = 'playHistory',
  otpEmailVerification = 'otpEmailVerification',
  contactUs = 'contactUs',
  membership = 'membership',
  community = 'community',
  lounges = 'lounges',
  courses = 'courses',
  createTournament = 'createTournament'
}
